import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from './ui/button';

const NotFound = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4" data-testid="not-found-page">
    <Helmet>
      <title>Pagina niet gevonden | Max Q</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="text-center max-w-lg">
      <p className="text-sm uppercase tracking-wide text-[#3a190b]/70 font-semibold mb-2">Fout 404</p>
      <h1 className="text-3xl md:text-4xl font-bold text-[#202020] mb-4">Deze pagina bestaat niet (meer)</h1>
      <p className="text-[#202020]/70 mb-8">Bekijk onze renovatiediensten of vraag meteen een gratis plaatsbezoek aan.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/"><Button className="bg-[#3a190b] hover:bg-[#500000] text-white px-6">Naar de homepage</Button></Link>
        <Link to="/start"><Button variant="outline" className="border-[#3a190b] text-[#3a190b] px-6">Gratis offerte</Button></Link>
      </div>
    </div>
  </div>
);

export default NotFound;
